import { pagesConfig } from '../../../shared/pages-config';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import Box from '@mui/material/Box';
import { HELPFUL_INFORMATION_BREADCRUMBS } from './helpful-information-utils';

export default function InsightsReleaseNotesPage() {
  const BREADCRUMBS = [
    ...HELPFUL_INFORMATION_BREADCRUMBS,
    { label: pagesConfig.insightsReleaseNotes.name },
  ];

  return (
    <SimpleBreadcrumbsPage breadcrumbs={BREADCRUMBS} shouldAllowHeightToScroll>
      <Box p={1}></Box>
    </SimpleBreadcrumbsPage>
  );
}
